"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaAction = exports.schema = exports.Schema = void 0;
const index_js_1 = require("../errors/index.js");
const resetLinks_js_1 = require("./utils/resetLinks.js");
class Schema {
    constructor(attributes) {
        var _a;
        this.type = 'schema';
        this.attributes = attributes;
        this.savedAttributeNames = new Set();
        this.keyAttributeNames = new Set();
        this.requiredAttributeNames = {
            always: new Set(),
            atLeastOnce: new Set(),
            never: new Set()
        };
        for (const attributeName in attributes) {
            if (this.savedAttributeNames.has(attributeName)) {
                throw new index_js_1.DynamoDBToolboxError('schema.duplicateAttributeNames', {
                    message: `Invalid schema: More than two attributes are named '${attributeName}'`,
                    payload: { name: attributeName }
                });
            }
            const attribute = attributes[attributeName];
            const attributeSavedAs = (_a = attribute.savedAs) !== null && _a !== void 0 ? _a : attributeName;
            if (this.savedAttributeNames.has(attributeSavedAs)) {
                throw new index_js_1.DynamoDBToolboxError('schema.duplicateSavedAsAttributes', {
                    message: `Invalid schema: More than two attributes are saved as '${attributeSavedAs}'`,
                    payload: { savedAs: attributeSavedAs }
                });
            }
            this.savedAttributeNames.add(attributeSavedAs);
            if (attribute.key) {
                this.keyAttributeNames.add(attributeName);
            }
            this.requiredAttributeNames[attribute.required].add(attributeName);
        }
    }
    pick(...attributeNames) {
        const nextAttributes = {};
        for (const attributeName of attributeNames) {
            if (!(attributeName in this.attributes)) {
                continue;
            }
            nextAttributes[attributeName] = (0, resetLinks_js_1.resetLinks)(this.attributes[attributeName]);
        }
        return new Schema(nextAttributes);
    }
    omit(...attributeNames) {
        const nextAttributes = {};
        const attributeNamesSet = new Set(attributeNames);
        for (const _attributeName of Object.keys(this.attributes)) {
            if (attributeNamesSet.has(_attributeName)) {
                continue;
            }
            const attributeName = _attributeName;
            nextAttributes[attributeName] = (0, resetLinks_js_1.resetLinks)(this.attributes[attributeName]);
        }
        return new Schema(nextAttributes);
    }
    and(additionalAttr) {
        const additionalAttributes = (typeof additionalAttr === 'function' ? additionalAttr(this) : additionalAttr);
        const nextAttributes = { ...this.attributes };
        for (const [attributeName, additionalAttribute] of Object.entries(additionalAttributes)) {
            if (attributeName in nextAttributes) {
                throw new index_js_1.DynamoDBToolboxError('schema.duplicateAttributeNames', {
                    message: `Invalid schema: More than two attributes are named '${attributeName}'`,
                    payload: { name: attributeName }
                });
            }
            nextAttributes[attributeName] = additionalAttribute.freeze(attributeName);
        }
        return new Schema(nextAttributes);
    }
    build(Action) {
        return new Action(this);
    }
}
exports.Schema = Schema;
/**
 * Defines an Entity schema
 *
 * @param attributes Dictionary of warm attributes
 * @return Schema
 */
const schema = (attributes) => new Schema({}).and(attributes);
exports.schema = schema;
class SchemaAction {
    constructor(schema) {
        this.schema = schema;
    }
}
exports.SchemaAction = SchemaAction;
